<div class="container-fluid wrapper-page">
    <div align="center" class="page-head">
        <h4 class="mt-2 mb-2">PATIENT PROFILE</h4>
    </div>
    <!-- <div>
        <h5><a href="javascript:void(0)"><i class="fa fa-arrow-circle-left" (click)="getback()"> BACK</i></a>
        </h5>
    </div> -->
    <div class="row">
        <div class="col-lg-12 col-12 col-sm-12 col-md-12">
            <div class="col-12 card m-b-30">
                <div class="card-body">
                    <ng-container>
                        <!-- PERSONEL INFO -->
                        <div class=" col-12 bg-primary text-white p-1">
                            <h5 class="mt-2 ml-4">Personal Information</h5>
                        </div>
                        <div align="right" class="font-italic text-danger  font-size-14 ml-5 text-right">
                            Note *
                            are Mandatory
                        </div>

                        <div class="card m-b-30 col-12">
                            <div class="card-body">
                                <section class="mt-35 ml-2 container" *ngFor="let tab of listOfTabs">
                                    <form [formGroup]="forms[tab.id]">
                                        <div class="row cust_row">
                                            <div [ngClass]="field.class" *ngFor="let field of form_fields[tab.id]">
                                                <sd-form-field [form]="forms[tab.id]" [applicationFormField]="field">
                                                </sd-form-field>
                                            </div>
                                        </div>
                                        <!-- <div class="col-6 container">
                                            <app-drag-drop *ngIf="tab.id === 'contactDetails'"
                                                (fileSelected)="fileSelected($event)" [supportedFormats]="'.png,.jpeg'"
                                                [multiple]="false">
                                            </app-drag-drop>
                                        </div> -->
                                    </form>
                                </section>
                            </div>
                        </div>
                        <!-- APPETITE HABITS -->


                        <!-- <div class="bg-primary text-white p-1">
                            <h5 class="mt-2 ml-4">Alcohol, Tobacco and Drug habits<span
                                    class="font-italic font-size-14 ml-2"></span></h5>
                        </div>
                        <div class="card m-b-30">
                            <div class="card-body">
                                <section class="mt-35 ml-2 align-items-center">
                                    <form [formGroup]="forms['appetiteHabits']">
                                        <div class="row cust_row habits">
                                            <div class="col-12 col-sm-12">
                                                <div class="form-group" formArrayName="patient_appetite"
                                                    *ngFor="let item of forms['appetiteHabits'].get('patient_appetite')['controls']; let i = index;">
                                                    <div class="row" [formGroupName]="i" class="width-100">
                                                        <div class="row">
                                                            <div class="col-2 col-sm-8 col-md-2 m-m margin-top-15">
                                                                <label for=""
                                                                    class="mt-3">{{getApetitleLabel(i)}}</label>
                                                            </div>
                                                            <div class="col-sm-2 col-md-1 ">
                                                                <label for="r1" class="margin-top-15 ">
                                                                    <input type="radio" value="Yes"
                                                                        formControlName="has_habit"
                                                                        class="margin-top-15 ">
                                                                    <i class="fa"></i>
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div class="col-sm-2 col-md-1">
                                                                <label for="r1" class="margin-top-15 ">
                                                                    <input type="radio" value="No"
                                                                        formControlName="has_habit"
                                                                        class="margin-top-15 ">
                                                                    <i class="fa"></i>
                                                                    No
                                                                </label>
                                                            </div>
                                                            <div class="col-2 col-sm-12 col-md-2">
                                                                <div align="left" class="text-dark">
                                                                    Habit Since
                                                                </div>
                                                                <select formControlName="since" name="since"
                                                                    class="form-control">
                                                                    <option value="">--Since--</option>
                                                                    <option *ngFor=" let item of yearList"
                                                                        [value]="item">
                                                                        {{ item }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                            <div class="col-3 col-sm-12 col-md-3">
                                                                <div align="left" class="text-dark">Enter Quantity
                                                                </div>
                                                                <input formControlName="habit_details" type="text"
                                                                    class="form-control" placeholder="No.of quantity">
                                                            </div>
                                                            <div class="col-3 col-sm-12 col-md-3">
                                                                <div align="left" class="text-dark">Frequency
                                                                </div>
                                                                <select name="frequency" formControlName="frequency"
                                                                    class="form-control">
                                                                    <option value="">--Select Frequency--</option>
                                                                    <option *ngFor=" let x of freqList"
                                                                        [value]="x.value">
                                                                        {{ x.value }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div *ngIf="formValidation(i, 'has_habit', 'patient_appetite')"
                                                            class="invalid-feedback">
                                                            Please choose Yes/No, It's Required.</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </section>
                            </div>
                        </div> -->

                        <!-- Medical History -->
                        <!-- <div class="bg-primary text-white p-1">
                            <h5 class="mt-2 ml-4">Medical History</h5>
                        </div>

                        <div class="card m-b-30">
                            <div class="card-body">
                                <section class="mt-35 ml-2 align-items-center text-center container"
                                    *ngIf="currentTab == 'appetiteHabits'">
                                    <form [formGroup]="forms['medicalHistory']">
                                        <div class="row cust_row">
                                            <div class="col-sm-12">
                                                <div class="form-group" formArrayName="patient_med_history"
                                                    *ngFor="let item of forms['medicalHistory'].get('patient_med_history')['controls']; let i = index;">
                                                    <div class="row col-12" [formGroupName]="i">

                                                        <div class="col-4 col-sm-6 col-md-4 ">
                                                            <div align="left" class="text-dark">Select Complication
                                                            </div>
                                                            <select name="disease_id" formControlName="disease_id"
                                                                class="form-control">
                                                                <option value="undefined">
                                                                    --Select Complication--</option>
                                                                <option *ngFor="let x of diseaseList" [value]="x.id">
                                                                    {{x.disease_name}}</option>
                                                            </select>
                                                        </div>

                                                        <div class="col-3 col-sm-6 col-md-3 ">
                                                            <div align="left" class="text-dark">Affected on
                                                            </div>
                                                            <select name="since" formControlName="since"
                                                                class=" form-control">
                                                                <option [value]="">
                                                                    --Since--</option>
                                                                <option *ngFor="let item of yearList;" [value]="item">
                                                                    {{item}}
                                                                </option>
                                                            </select>
                                                        </div>
                                                        <div class="col-3 col-sm-10 col-md-3 ">
                                                            <div align="left" class="text-dark">Enter More info
                                                            </div>
                                                            <input formControlName="med_hist_info" type="text"
                                                                class="form-control"
                                                                placeholder="Specify more information">
                                                        </div>

                                                        <div class="col-2 col-sm-3 col-md-2" style="margin-top: 22px;"
                                                            *ngIf=" i < (forms['medicalHistory'].get('patient_med_history')['controls'].length - 1)">
                                                            <div>
                                                                <button type="button"
                                                                    class="btn btn-outline-primary removeitem "
                                                                    (click)="removingMedicalHistory(i)"
                                                                    style="padding: 12px 16px;"><i
                                                                        class="fa fa-close"></i></button>
                                                            </div>
                                                        </div>

                                                        <div class="col-2 col-sm-3 col-md-2 " style="margin-top: 22px;"
                                                            *ngIf="i === (forms['medicalHistory'].get('patient_med_history')['controls'].length - 1)">
                                                            <div>
                                                                <button type="button"
                                                                    class="btn btn-outline-primary addmore"
                                                                    style="padding: 12px 16px;"
                                                                    (click)="addingMoreMedicalHistory();"><i
                                                                        class="fa fa-plus"></i></button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </section>
                            </div>
                        </div> -->

                        <!-- ================= Current Medication ============= -->
                        <!-- <div class="bg-primary text-white p-1">
                            <h5 class="mt-2 ml-4">Medicine History</h5>
                        </div>
                        <div class="card m-b-30">
                            <div class="card-body">
                                <section class="mt-35 ml-2 align-items-center text-center container">
                                    <form [formGroup]="forms['currentMedication']">
                                        <div class="row cust_row">

                                            <div class="col-sm-12">
                                                <div class="form-group" formArrayName="patient_medication"
                                                    *ngFor="let item of forms['currentMedication'].get('patient_medication')['controls']; let i = index;">
                                                    <div class="row" [formGroupName]="i">

                                                        <div class="col-12 col-sm-12 col-md-5 m-m">
                                                            <div align="left" class="text-dark">Drug name
                                                            </div>
                                                            <input id="text" name="pmed_dose" type="text"
                                                                class="form-control" placeholder="Drugs"
                                                                formControlName="pmed_dose">
                                                        </div>

                                                        <div class="col-8 col-sm-10 col-md-5 m-m">
                                                            <div align="left" class="text-dark">Select frequency
                                                            </div>
                                                            <select name="pmed_freq" class="form-control"
                                                                formControlName="pmed_freq">

                                                                <option *ngFor=" let x of freqList" [value]="x.value">
                                                                    {{ x.value }}
                                                                </option>
                                                            </select>
                                                        </div>

                                                        <div class="col-4 col-sm-2 col-md-1 m-m text-right"
                                                            style="margin-top: 22px;"
                                                            *ngIf=" i <(forms['currentMedication'].get('patient_medication')['controls'].length - 1)">
                                                            <button type="button" (click)="removingCurrentMedication(i)"
                                                                class="btn btn-outline-primary removeitem"
                                                                style="padding: 12px 16px;"><i
                                                                    class="fa fa-close"></i></button>
                                                        </div>
                                                        <div class="col-4 col-sm-2 col-md-1 m-m text-right"
                                                            style="margin-top: 22px;"
                                                            *ngIf="i === (forms['currentMedication'].get('patient_medication')['controls'].length - 1)">
                                                            <button type="button" (click)="addingCurrMedication()"
                                                                class="btn btn-outline-primary addmore"
                                                                style="padding: 12px 16px;"><i
                                                                    class="fa fa-plus"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </section>
                            </div>
                        </div> -->

                        <!-- ================= family History ============= -->
                        <!-- <div class="bg-primary text-white p-1">
                            <h5 class="mt-2 ml-4">Family Medical History</h5>
                        </div>
                        <div class="card m-b-30">
                            <div class="card-body">
                                <section class="mt-35 ml-2 align-items-center">
                                    <form [formGroup]="forms['fammedhistory']">
                                        <div class="row ">
                                            <div class="col-12 col-sm-12">
                                                <div class="form-group" formArrayName="patient_fmed_history"
                                                    *ngFor="let item of forms['fammedhistory'].get('patient_fmed_history')['controls']; let i = index;">
                                                    <div class="row" [formGroupName]="i" class="width-100">
                                                        <div class="row">
                                                            <div
                                                                class="col-2 col-sm-8 col-md-1 m-m margin-top-15 text-dark font-weight-bold">
                                                                <div *ngIf="i === 0">
                                                                    <label class=""> FATHER</label>

                                                                </div>
                                                                <div *ngIf="i === 1">
                                                                    <label class="">MOTHER</label>

                                                                </div>
                                                                <div *ngIf=" i===2">
                                                                    <label class="">SIBLINGS</label>

                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12 col-md-5 margin-top-15 ">

                                                                <input type="checkbox" formControlName="diabetic"
                                                                    name="diabetic">
                                                                Diabetic

                                                                <input type="checkbox" formControlName="cardio"
                                                                    name="cardio">
                                                                Cardio Vascular

                                                                <input type="checkbox" formControlName="tension"
                                                                    name="tension">
                                                                Hyper Tension

                                                                <input type="checkbox" formControlName="cholestral"
                                                                    name="cholestral">
                                                                High Cholestral

                                                            </div>
                                                            <div class="col-2 col-sm-12 col-md-2">
                                                                <div align="left" class="text-dark">Select status
                                                                </div>
                                                                <select name="live_status" class=" form-control"
                                                                    formControlName="status" name="status">
                                                                    <option value=""> --Live Status-- </option>
                                                                    <option value="Alive">Alive </option>
                                                                    <option value="Deceased">Deceased </option>
                                                                </select>
                                                            </div>
                                                            <div class="col-3 col-sm-12 col-md-3">
                                                                <div align="left" class="text-dark">Enter Reason
                                                                </div>
                                                                <input class="form-control" type="text"
                                                                    placeholder="If Deceased, due to"
                                                                    formControlName="remarks" name="remarks">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </section>
                            </div>
                        </div> -->


                        <!-- LIFE STYLE -->
                        <!-- <div class="bg-primary text-white p-1">
                            <h5 class="mt-2 ml-4">Life Style</h5>
                        </div>
                        <div class="card m-b-30">
                            <div class="card-body">
                                <section class="mt-35 ml-2 align-items-center">
                                    <form [formGroup]="forms['lshistory']">
                                        <div class="row ">
                                            <div class="col-12 col-sm-12">
                                                <div class="form-group" formArrayName="patient_lifestyle"
                                                    *ngFor="let item of forms['lshistory'].get('patient_lifestyle')['controls']; let i=index;">

                                                    <div class="row" [formGroupName]="i" class="width-100">
                                                        <div class="row">
                                                            <div
                                                                class="col-sm-12 col-md-3 margin-top-20  text-dark font-weight-bold">
                                                                <div *ngIf="i === 0" class="margin-top-20 ">
                                                                    EXERCISE
                                                                </div>
                                                                <div *ngIf="i === 1" class="margin-top-20 ">
                                                                    WALKING / RUNNING
                                                                </div>
                                                                <div *ngIf=" i===2" class="margin-top-20">
                                                                    WORKING HOURS
                                                                </div>
                                                            </div>

                                                            <div class="col-sm-12 col-md-2 mt-3  ">
                                                                <div align="left" class="text-dark">Hours
                                                                </div>
                                                                <input class="form-control" type="text"
                                                                    formControlName="duration" name="duration"
                                                                    placeholder="Enter total hours">
                                                            </div>
                                                            <div class="col-sm-1 col-md-1 mt-3  "></div>
                                                            <div class="col-sm-12 col-md-3 mt-3">
                                                                <div align="left" class="text-dark">Select Frequency
                                                                </div>
                                                                <select class="form-control" formControlName="freq"
                                                                    name="freq">
                                                                    <option value="">--Select Frequency--</option>
                                                                    <option *ngFor=" let x of freqList"
                                                                        [value]="x.value">
                                                                        {{ x.value }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </section>
                            </div>
                        </div> -->
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-8"></div>
        <div class="col-2"></div>
        <div class="col-2">
            <button type="button" class="btn btn-primary btn-patient pull-right" (click)="savePatient()">CONSULT
                NOW</button>
        </div>

    </div>
</div>
<!--end container-->